import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 58 58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "29",
        cy: "29",
        r: "29",
        "fill-opacity": ".12"
      }),
      _createElementVNode("path", {
        "fill-rule": "nonzero",
        d: "M21.689 14.255c-3.482 0-6.315 3.094-6.315 6.896s2.833 6.896 6.315 6.896 6.314-3.093 6.314-6.896-2.832-6.896-6.314-6.896m14.357.987h-.043c-1.462.013-2.827.648-3.844 1.79-.999 1.121-1.542 2.6-1.53 4.165s.58 3.035 1.597 4.14c1.025 1.112 2.383 1.723 3.828 1.723h.043c1.462-.012 2.827-.648 3.844-1.79.999-1.12 1.542-2.6 1.53-4.165-.026-3.242-2.456-5.863-5.425-5.863m.266 12.948h-.524c-2.442 0-4.671.956-6.353 2.523a12.55 12.55 0 0 1 3.816 5.082c.554 1.349.87 2.77.944 4.234q2.268 1.392 5.797 1.392t5.797-1.392v-2.08c0-5.38-4.251-9.76-9.477-9.76zM31.19 39.115a9.57 9.57 0 0 0-3.704-7.031 9 9 0 0 0-5.511-1.88h-.572c-5.1 0-9.234 4.258-9.234 9.51v1.13q4.76 1.893 9.52 1.893t9.519-1.894v-1.128q0-.303-.019-.6z"
      })
    ], -1)
  ]))]))
}
export default { render: render }